module.exports = __webpack_public_path__ + "img/DJI_0076(1).8a15654f.jpg";